import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { useLocation } from "react-router-dom";

// 🔥 1. IMPORTS FOR TRACKING
import { db } from "../firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const Layout = ({ children, onLogout, notificationCount }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  // =========================================================
  // 🕵️‍♂️ AUTO-TRACKER LOGIC (Every 30 Mins)
  // =========================================================
  useEffect(() => {
    const sendLocation = () => {
        if (!navigator.geolocation) return; 

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                try {
                    // User Data uthao (LocalStorage ya Auth se)
                    // Note: Ensure karein ki login ke waqt aapne user data save kiya ho
                    const userStr = localStorage.getItem("user_data"); // Ya "user" check karein
                    const user = userStr ? JSON.parse(userStr) : null;

                    if (user) {
                        await addDoc(collection(db, "location_logs"), {
                            userId: user.email || user.uid || "unknown",
                            userName: user.name || user.displayName || "Employee",
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                            timestamp: serverTimestamp(),
                            date: new Date().toISOString().split('T')[0],
                            time: new Date().toLocaleTimeString(),
                            type: "Auto-Track (30min)"
                        });
                        console.log("📍 Auto-Track: Location Sent to DB");
                    }
                } catch (error) {
                    console.error("Tracking Error:", error);
                }
            },
            (error) => {
                console.log("GPS Error/Blocked:", error.message);
            }
        );
    };

    // 1. Send immediately on load
    sendLocation();

    // 2. Set Interval for 30 Minutes (30 * 60 * 1000)
    const tracker = setInterval(sendLocation, 30 * 60 * 1000);

    return () => clearInterval(tracker); // Cleanup on unmount
  }, []);
  // =========================================================


  // 1. Resize Logic
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) setIsSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 2. Route change hone par auto-close
  useEffect(() => {
    if (isMobile) setIsSidebarOpen(false);
  }, [location, isMobile]);

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden", flexDirection: "column", background: "#f4f6f8" }}>
      
      {/* 🔥 NEW STICKY MOBILE HEADER */}
      {isMobile && (
        <div style={modernMobileHeader}>
            <div style={{display:"flex", alignItems:"center", gap:"15px"}}>
                {/* Hamburger with Ripple Effect styling */}
                <button onClick={() => setIsSidebarOpen(true)} style={iconBtn}>
                    <span style={{fontSize:"20px"}}>☰</span>
                </button>
                <span style={{fontWeight:"700", fontSize:"18px", color:"#2c3e50", letterSpacing:"0.5px"}}>Life Line</span>
            </div>

            {/* Right Side Icons (Quick Access) */}
            <div style={{display:"flex", alignItems:"center", gap:"15px"}}>
                <div style={{position:"relative", cursor:"pointer"}}>
                    <span style={{fontSize:"20px"}}>🔔</span>
                    {notificationCount > 0 && <span style={badgeStyle}>{notificationCount}</span>}
                </div>
                <div style={avatarCircle}>A</div>
            </div>
        </div>
      )}

      <div style={{ display: "flex", flex: 1, overflow: "hidden", position: "relative" }}>
        
        {/* 🔥 SIDEBAR WITH GLASS EFFECT */}
        <div style={{
            width: "260px",
            flexShrink: 0,
            height: "100%",
            position: isMobile ? "absolute" : "relative",
            left: isMobile ? (isSidebarOpen ? "0" : "-270px") : "0", 
            top: 0,
            zIndex: 1000,
            transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)", // Smooth Physics animation
            backgroundColor: "white",
            boxShadow: isMobile && isSidebarOpen ? "10px 0 30px rgba(0,0,0,0.15)" : "none",
            borderRight: "1px solid #eee",
            borderTopRightRadius: isMobile ? "15px" : "0", // Rounded Corner on Mobile
            borderBottomRightRadius: isMobile ? "15px" : "0"
        }}>
           {isMobile && (
             <div style={{padding:"15px", borderBottom:"1px solid #f0f0f0", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                 <span style={{fontWeight:"bold", color:"#888"}}>MENU</span>
                 <button onClick={() => setIsSidebarOpen(false)} style={closeBtn}>✖</button>
             </div>
           )}
           
           <Sidebar onLogout={onLogout} notificationCount={notificationCount} />
        </div>

        {/* 🔥 BLUR OVERLAY (Backdrop Filter) */}
        {isMobile && isSidebarOpen && (
          <div 
            onClick={() => setIsSidebarOpen(false)} 
            style={glassOverlay}
          ></div>
        )}

        {/* MAIN CONTENT AREA */}
        <div style={{ 
            flex: 1, 
            overflowY: "auto", 
            padding: isMobile ? "15px" : "25px", 
            width: "100%",
            scrollBehavior: "smooth"
        }}>
          {children}
        </div>

      </div>
    </div>
  );
};

// ✨ NEW MODERN STYLES
const modernMobileHeader = {
    padding: "12px 20px",
    background: "rgba(255, 255, 255, 0.95)", // Thoda transparent
    backdropFilter: "blur(10px)", // 🔥 Glass Effect
    borderBottom: "1px solid rgba(0,0,0,0.05)",
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center", 
    zIndex: 900,
    boxShadow: "0 4px 20px rgba(0,0,0,0.03)", // Soft Shadow
    position: "sticky", // 🔥 Sticks to top
    top: 0
};

const iconBtn = {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: "5px",
    display: "flex",
    alignItems: "center",
    color: "#2c3e50"
};

const avatarCircle = {
    width: "32px",
    height: "32px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    fontSize: "14px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
};

const badgeStyle = {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    background: "#e74c3c",
    color: "white",
    fontSize: "10px",
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    border: "2px solid white"
};

const closeBtn = {
    background: "#f8f9fa",
    color: "#555",
    border: "none",
    padding: "8px 12px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "bold"
};

const glassOverlay = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.4)", // Darker overlay
    backdropFilter: "blur(4px)", // 🔥 Blur Effect (Jadu)
    zIndex: 999,
    transition: "opacity 0.3s ease"
};

export default Layout;